import { addLastPrefixES } from '../transforms/addLastPrefix';
import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { formatShortMonthESLA } from '../transforms/formatShortMonth';
import { formatTime12h } from '../transforms/formatTime';
import { removeDots } from '../transforms/removeDots';
import { uppercase } from '../transforms/uppercase';
import { overrideBaseLocale } from './base-config';
export var esLA = overrideBaseLocale('es-LA', {
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [uppercase, removeDots],
    },
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [capitalizeFirstLetter, removeDots],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixES],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [formatShortMonthESLA],
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [uppercase, formatShortMonthESLA],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter, formatShortMonthESLA],
    },
    time: {
        options: {
            timeStyle: 'short',
        },
        transforms: [formatTime12h],
    },
});
//# sourceMappingURL=es-LA.js.map